import AppBarAwareDrawer from 'Components/AppBarAwareDrawer'
import { isPtaBannerVisible } from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { t } from 'ttag'

interface DrawerRightProps {
  open: boolean
  onClose: () => void
  topBar?: ReactNode
  children: ReactNode
  sx?: SxProps<Theme>
}

function DrawerRight({ open, onClose, topBar, children, sx }: Readonly<DrawerRightProps>) {
  const { user } = useTypedSelector(state => state.user)
  const location = useLocation()
  return (
    <AppBarAwareDrawer
      isPtaBannerVisible={isPtaBannerVisible(user, location)}
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: { invisible: true },
        paper: {
          sx: {
            width: '45%',
            minWidth: '600px',
            maxWidth: '750px',
            ...sx
          }
        }
      }}
    >
      <Box sx={{ p: '10px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            sx={{ color: 'text.secondary' }}
            variant="text"
            onClick={onClose}
            startIcon={<CloseIcon />}
          >
            {t`Close`}
          </Button>
          {topBar}
        </Box>
      </Box>
      {children}
    </AppBarAwareDrawer>
  )
}

export default DrawerRight
